import { render, staticRenderFns } from "./option-selector.vue?vue&type=template&id=663847ee&scoped=true"
import script from "./option-selector.vue?vue&type=script&lang=js"
export * from "./option-selector.vue?vue&type=script&lang=js"
import style0 from "./option-selector.vue?vue&type=style&index=0&id=663847ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663847ee",
  null
  
)

export default component.exports